module.exports = __webpack_public_path__ + "static/about-us-dc3d0a0f2075fe64ef077343226f50b9.jpg";